import { SEND_EMAIL_ERROR, SEND_EMAIL_SUCCESS, SEND_EMAIL_REQUEST } from "./types";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const sendEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/PickTicketEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};
// Not Approved
export const sendOrderConfirmationEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderConfirmationEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};


export const sendOrderConfirmationApprovedEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderConfirmationApprovedSOEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};

export const sendOrderCreditCardDeclinedEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderCreditCardDeclinedEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};

export const sendOrderConfirmationOnHoldEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderConfirmationOnHoldSOEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};



export const sendOrderConfirmationAutoApprovedPTEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderConfirmationAutoApprovedPTEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};

export const sendOrderPaymentDuePTEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderPaymentDuePTEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};

export const sendOrderConfirmationConsignmentEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderConfirmationConsignmentEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};
export const sendOrderShippedConfirmationInvoiceEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderShippedConfirmationInvoiceEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};
export const sendOrderNotedEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderNotedEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};


export const createCCPaymentLink = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}payment/cc/create-payment-link`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            shipHeaderNo: data.ship_header_no,
            netAmount: data.net_amount
            ? Math.round(parseFloat(data.net_amount) * 100) // convert dollars → cents
            : undefined

        }
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};

export const sendCCPaymentEmail = (token, data) => dispatch => {
    dispatch({ type: SEND_EMAIL_REQUEST });
    console.log("data", data)
    return axios({
        method: "POST",
        url: `${BASEURL}communication/sendCCPaymentEmail`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        // data: {
        //     ship_header_id: data.ship_header_id,
        //     payment_link: data.payment_link,
        //     is_approved: data.is_approved ? true : false,

        // }
        data:data
    })
        .then(response => {
            return dispatch({
                type: SEND_EMAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch(error => {
            return dispatch({ type: SEND_EMAIL_ERROR, payload: error.response });
        });
};